/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API50800Req {
  
  /** 里程碑计划编号 */
  planNo?: string;
  /** 新状态：1未开始2进行中3已完成 */
  newStatus?: number;
};



export type API50800Res = {};


// 50800 更新里程碑状态

export interface IUsePostAPI50800Return {
  /** 更新里程碑状态: 接口请求状态 */
  isAPI50800Loading: boolean;
  /** 更新里程碑状态: 接口请求返回数据 */
  dataAPI50800: API50800Res;
  /**  更新里程碑状态: 接口数据请求方法 */
  fetchAPI50800Data:  (inputs: API50800Req, config?: YWRequestConfig) => Promise<API50800Res>;
  /** 更新里程碑状态: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50800 = ():IUsePostAPI50800Return => {
  let isMount = true;
  const [isAPI50800Loading, setIsAPI50800Loading] = useState(false);
  const [dataAPI50800, setDataAPI50800] = useState<API50800Res>({} as API50800Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/update/status`;

  const fetchAPI50800Data = async (inputs: API50800Req, config?: YWRequestConfig): Promise<API50800Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50800Req>) || {}) as API50800Req;
    
  
    if ( isMount ) {
      setIsAPI50800Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50800Res>(`${basePath}/corp-admin/project/plan/update/status`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50800(res || {} as API50800Res);
        setIsAPI50800Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50800Loading(false);
      }
      return false as unknown as API50800Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50800Loading,
    dataAPI50800,
    fetchAPI50800Data,
    requestUrl,
  }
}

